import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const WarningInfo = (props) => {
    const {content} = props;
    if(!content) return '';

    return <div className='home-warning-info'>
        <div className='home-warning-info-container'>
            <i className='home-warning-info-icon'>!</i>
            <span className='home-warning-info-text'>{content.text} {content.url && <a href={content.url} target='_blank' rel='noopener noreferrer'>Ver más</a>}</span>
        </div>
    </div>;
}

WarningInfo.propTypes = {
    content: PropTypes.object
}

export default WarningInfo;
